module.exports = __webpack_public_path__ + "img/czbj.18cb09a4.png";